import React from "react";
import { Link } from "react-router-dom";
import { Flex, Text, Stack, Anchor } from "@mantine/core";
import { IconUser, IconExternalLink } from "@tabler/icons-react";

export default function EmployeeMeta({
  name,
  email,
  id,
  employeeId,
  companyName,
  companyId,
  position,
}) {
  return (
    <Flex align="center" gap="xs">
      <IconUser size={50} />
      <Stack gap={1}>
        <Flex gap="xs">
          <Text
            component={Link}
            c="dark"
            to={`/employees/${employeeId}`}
            fw={700}
          >
            {name}
          </Text>
        </Flex>
        <Text>{email}</Text>
        <Text component={Link} c="dark" to={`/companies/${companyId}`}>
          {companyName}
        </Text>
        {position && <Text>{position}</Text>}
      </Stack>
    </Flex>
  );
}

EmployeeMeta.defaultProps = {
  name: "",
  email: "",
  id: null,
  companyName: "",
  companyId: "",
  position: "",
};
